module.exports = __webpack_public_path__ + "img/ic-arrow2.cff280f3.svg";